"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WinstonLogger = void 0;
const winston = require("winston");
const Logger_1 = require("../abstract/Logger");
const LogLevel_1 = require("../abstract/LogLevel");
const Stream = require("stream");
class WinstonLogger extends Logger_1.Logger {
    constructor(optionsOrLogger) {
        super();
        if (optionsOrLogger instanceof Stream) {
            this.logger = optionsOrLogger;
        }
        else {
            this.logger = winston.createLogger(optionsOrLogger !== null && optionsOrLogger !== void 0 ? optionsOrLogger : {
                format: winston.format.combine(winston.format.timestamp(), winston.format.json()),
                transports: [
                    new winston.transports.Console({
                        level: "debug",
                    }),
                ],
            });
        }
    }
    log(log) {
        const { level, message, meta } = log;
        if (level === LogLevel_1.LogLevel.Fatal) {
            this.logger.log({
                level: "fatal",
                message: message,
                meta,
            });
        }
        if (level === LogLevel_1.LogLevel.Error) {
            this.logger.log({
                level: "error",
                message: message,
                meta,
            });
        }
        if (level === LogLevel_1.LogLevel.Warn) {
            this.logger.log({
                level: "warn",
                message: message,
                meta,
            });
        }
        if (level === LogLevel_1.LogLevel.Info) {
            this.logger.log({
                level: "info",
                message: message,
                meta,
            });
        }
        if (level === LogLevel_1.LogLevel.Debug) {
            this.logger.log({
                level: "debug",
                message: message,
                meta,
            });
        }
        if (level === LogLevel_1.LogLevel.Trace) {
            this.logger.log({
                level: "silly",
                message: message,
                meta,
            });
        }
    }
    createChild(meta) {
        return new WinstonLogger(this.logger.child(meta));
    }
    close() {
        this.logger.close();
    }
}
exports.WinstonLogger = WinstonLogger;
//# sourceMappingURL=WinstonLogger.js.map